import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getMountPath } from 'utils/generic/route-manipulation';
import { ENotRealSports } from 'interfaces/not-real-sports';
import { EAdvancedCouponsLayouts } from 'interfaces/sportsbook';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { useSbSportsbookRouteMatch } from 'newhooks/sportsbook/useSbSportsbookRouteMatch';

const SOCCER_ALIAS = 'Soccer';

export const useRedirectToAdvancedRoute = () => {
  const history = useHistory();

  const generatedUrl = useSbSportsbookRouteMatch(
    '/:sport?/:region?/:competition?/:game?'
  );

  const routeParams = useSbRouteMatch(generatedUrl);

  useLayoutEffect(() => {
    if (routeParams) {
      const { params, path } = routeParams;

      if (params.category && params.category === ENotRealSports.todayEvents) {
        // as we don't know which sport to select, we decided to redirect to Soccer
        const newRoute = `${getMountPath(path)}/${SOCCER_ALIAS}ss?coupon=${
          EAdvancedCouponsLayouts.todayMatches
        }`;

        history.push(newRoute);

        return;
      }

      if (params.sport && params.region && params.competition && !params.game) {
        const newRoute = `${getMountPath(path)}?compIds=${params.competition}`;

        history.push(newRoute);
      }
    }
  }, [routeParams?.params]);
};
